import { initStore } from '../../../common';
import { actions } from './actions';

export const rolesPermissionsStore = (): void => {
	const initialState = {
		slice: 'ROLE_PERMISSIONS',
		roles: [],
		rows: [],
		columns: ['Roles', 'Members', ''],
		globalErrors: [],
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
